import { Flex, Badge, Button, Loader } from '@aws-amplify/ui-react'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { useComponentSize } from '../components/ResponsiveSize'

export function PeanutsBalance({ balance, isLoading }: { balance: number, isLoading?: boolean }) {
  const navigate = useNavigate()
  const componentSize = useComponentSize()

  const showLoading = isLoading || Number.isNaN(balance)

  return (
    <Flex direction='row' alignItems='center'>
      {showLoading ? (
        <Badge size={componentSize === 'short' ? 'small' : 'large'} variation='info'>
          <Loader size="small" /> Balance...
        </Badge>
      ) : (
        <Badge
          data-testid='balance'
          size={componentSize === 'short' ? 'small' : 'large'}
          variation={balance.valueOf() > 0 ?
            balance.valueOf() > 5 ? 'info' :
              'warning' :
            'error'}>{componentSize === 'short' ? `${balance.valueOf()} 🥜` : `Balance: ${balance.valueOf()} 🥜`}
        </Badge>
      )}
      <Button size={componentSize === 'short' ? 'small' : undefined} variation="link" onClick={() => navigate('/pricing')}>➕ Buy</Button>
    </Flex>
  )
}
